import React from 'react';
import PropTypes from 'prop-types';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 12,
    fontFamily: 'Helvetica',
    color: '#333',
    backgroundColor: '#f9f9f9',
  },
  header: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: 1.5,
    color: '#2c3e50',
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderColor: '#e0e0e0',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableColHeader: {
    width: '33.33%',
    borderStyle: 'solid',
    borderColor: '#e0e0e0',
    borderBottomColor: '#333',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: '#f0f0f0',
    padding: 8,
  },
  tableCol: {
    width: '33.33%',
    borderStyle: 'solid',
    borderColor: '#e0e0e0',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 8,
  },
  tableCellHeader: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#2c3e50',
  },
  tableCell: {
    fontSize: 10,
    color: '#444',
  },
  boldText: {
    fontWeight: 'bold',
  },
  italicText: {
    fontStyle: 'italic',
  },
  underlineText: {
    textDecoration: 'underline',
  },
});

const formatTimestamp = (timestamp) => {
  if (!timestamp) return 'Data não disponível';
  const date = timestamp instanceof Date ? timestamp : timestamp.toDate();
  return date.toLocaleDateString('pt-BR');
};

const renderHtmlText = (htmlString) => {
  const regexBold = /<b>(.*?)<\/b>/g;
  const regexItalic = /<i>(.*?)<\/i>/g;
  const regexUnderline = /<u>(.*?)<\/u>/g;

  let formattedText = htmlString
    .replace(regexBold, (_, match) => `<b>${match}</b>`)
    .replace(regexItalic, (_, match) => `<i>${match}</i>`)
    .replace(regexUnderline, (_, match) => `<u>${match}</u>`);

  return formattedText.split(/<br\s*\/?>/i).map((line, index) => (
    <Text key={index} style={styles.tableCell}>
      {line.split(/<[^>]+>/).map((text, i) => {
        if (line.includes(`<b>${text}</b>`)) {
          return (
            <Text key={i} style={styles.boldText}>
              {text}
            </Text>
          );
        }
        if (line.includes(`<i>${text}</i>`)) {
          return (
            <Text key={i} style={styles.italicText}>
              {text}
            </Text>
          );
        }
        if (line.includes(`<u>${text}</u>`)) {
          return (
            <Text key={i} style={styles.underlineText}>
              {text}
            </Text>
          );
        }
        return text;
      })}
    </Text>
  ));
};

const RelatorioPDF = ({ atendimentos }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
        <Text>Relatório de Atendimentos</Text>
      </View>

      <View style={styles.table}>
        {/* Table Header */}
        <View style={styles.tableRow}>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCellHeader}>Data de Atendimento</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCellHeader}>Clínica de Atendimento</Text>
          </View>
          <View style={styles.tableColHeader}>
            <Text style={styles.tableCellHeader}>Observação</Text>
          </View>
        </View>

        {/* Table Rows */}
        {atendimentos.map((atendimento, index) => (
          <View key={index} style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>
                {formatTimestamp(atendimento.dataAtendimento)}
              </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>
                {atendimento.clinicaNome || 'Clínica não disponível'}
              </Text>
            </View>
            <View style={styles.tableCol}>
              {renderHtmlText(atendimento.observacao || 'Sem observação')}
            </View>
          </View>
        ))}
      </View>
    </Page>
  </Document>
);
RelatorioPDF.propTypes = {
  atendimentos: PropTypes.arrayOf(
    PropTypes.shape({
      dataAtendimento: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
      ]),
      clinicaNome: PropTypes.string,
      observacao: PropTypes.string,
    })
  ).isRequired,
};

export default RelatorioPDF;
